import type { GraderMarkupDocumentV1 } from './markup';

export function WorksheetMarkupLayer({ document }: { document: GraderMarkupDocumentV1 }) {
  return (
    <svg className="v2-markup-layer" viewBox="0 0 1000 1320" preserveAspectRatio="none" aria-label="Tutor/grader markup">
      {document.items.map((item) => {
        const symbol = item.kind === 'approved_mark' ? '✓' : item.kind === 'teacher_note' ? '•' : '×';
        return <text key={item.markupId} x={item.x} y={item.y} className={`v2-markup v2-markup--${item.kind}`}>{symbol}</text>;
      })}
    </svg>
  );
}
